
/*
 * happens when navigation button is click
 */
function goback (e) { 
    this.navigate(`/schedules${window.location.search}`, {replace: true });
    // const hasLoading = window.location.pathname === '/loading';
    /*
    if (window.location.pathname === '/' ||
        hasLoading
    ) {
        const qs = window.location.search.split('?');
        const query = qs[qs.length-1];
        console.log('query -> ', query );
        window.location.assign(`?${query}`);
    }
    this.fixURLHistory(window.location.pathname,  window.location.search);
    */
}

export default goback;
